import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { AidYearChange } from 'app/_models/calcPackage';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-selector-changes-dialog',
    templateUrl: './selector-changes-dialog.component.html',
    styleUrls: ['./selector-changes-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class SelectorChangesDialogComponent implements OnDestroy {
  copied = false;
  copyFeedbackMessage = '';
  readonly copyFeedbackId = 'selector-changes-copy-feedback';
  private resetCopyStateTimeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(
    public dialogRef: MatDialogRef<SelectorChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AidYearChange[],
    private clipboard: Clipboard
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }


  copyToClipboard(): void {
    const headers = ['Entity', 'Name', 'Old Selector', 'New Selector'];
    const rows = this.data.map(aidYearChange => [aidYearChange.entity, aidYearChange.name, aidYearChange.oldSelector, aidYearChange.newSelector]);
    const table = [headers, ...rows].map(row => row.join('\t')).join('\n');
    const copySucceeded = this.clipboard.copy(table);

    this.copied = copySucceeded;
    this.copyFeedbackMessage = copySucceeded
      ? 'Selector changes table copied to the clipboard.'
      : 'Unable to copy selector changes table to the clipboard. Please try again.';

    this.startCopyResetTimer();
  }

  ngOnDestroy(): void {
    if (this.resetCopyStateTimeoutId) {
      clearTimeout(this.resetCopyStateTimeoutId);
    }
  }

  private startCopyResetTimer(): void {
    if (this.resetCopyStateTimeoutId) {
      clearTimeout(this.resetCopyStateTimeoutId);
    }

    this.resetCopyStateTimeoutId = setTimeout(() => {
      this.copied = false;
      this.copyFeedbackMessage = '';
      this.resetCopyStateTimeoutId = null;
    }, 4000);
  }
}
